import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function BeforeAfter() {
  return <section className="bg-cream px-5 py-16 md:py-24" data-id="element-71" data-mp="26k9xmja7pdch">
      <div className="mx-auto max-w-5xl" data-id="element-72" data-mp="22lkd86qravjc">
        <SectionHeading eyebrow="The transformation" title={<>
              What should you be able to do <em className="italic text-gold-dark" data-id="element-74" data-mp="2uc6xdc0e0ex8">after</em> using the system?
            </>} data-id="element-73" data-mp="22iodccvclws9" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-75" data-mp="2q9kc5ty81s90">
          <div className="rounded-3xl border border-alert/20 bg-white p-6 md:p-8" data-id="element-76" data-mp="2qc6ixrdag3q6">
            <p className="inline-flex items-center gap-2 rounded-full bg-alert px-4 py-1.5 text-sm font-black uppercase tracking-widest text-white" data-id="element-77" data-mp="2lazbxuiyz8kk">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="19vke6oixscoe" />
              Before
            </p>
            <ul className="mt-5 space-y-3.5" data-id="element-79" data-mp="174ukmqvi573r">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-navy/80" data-id="element-80" data-mp="1c477hbmdie6c">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-alert/10 text-alert" data-id="element-81" data-mp="y57ho0n4jt8l">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-82" data-mp="132po9kdo5wdf" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 ring-4 ring-cta/40 md:p-8" data-id="element-83" data-mp="t5ux5mjq6y96">
            <p className="inline-flex items-center gap-2 rounded-full bg-cta px-4 py-1.5 text-sm font-black uppercase tracking-widest text-white" data-id="element-84" data-mp="feg7iwvbbyt5">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-85" data-mp="jgb7ny1ic65c" />
              After
            </p>
            <ul className="mt-5 space-y-3.5" data-id="element-86" data-mp="5gikudt3qa2n">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-87" data-mp="aek5h366ehg8">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-88" data-mp="2c5keko1gibb2">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="27bpu3ie11sax" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center" data-id="element-90" data-mp="2v350bm8xctrg">
          <p className="text-[17px] text-navy/75" data-id="element-91" data-mp="2v2c1d7g7j8jv">The goal isn't to give you more information.</p>
          <p className="font-serif text-2xl font-black text-navy md:text-3xl" data-id="element-92" data-mp="2r2bb8pjqx8wz">
            The goal is to help you get more value from the information{" "}
            <em className="italic text-gold-dark" data-id="element-93" data-mp="2h45badhi2cur">you already have.</em>
          </p>
        </div>

        <SectionCta label="I want to develop a better case-review process" data-id="element-94" data-mp="1anjuj9vypq3i" />
      </div>
    </section>;
}